import { HTMLAttributes, MouseEventHandler, forwardRef } from 'react';
import { Button } from '../../button/button';
import { Icon } from '../../icon/icon';
import { UploadingFile } from '../types';
import './file-upload-progress.css';
import { useDevice, useWindowSize } from '@/ui-kit/hooks';

interface FileUploadProgressProps extends HTMLAttributes<HTMLDivElement> {
  file: UploadingFile;
  onCancel?: MouseEventHandler<HTMLButtonElement>;
  onDelete?: MouseEventHandler<HTMLButtonElement>;
}

const FileUploadProgress = forwardRef<HTMLDivElement, FileUploadProgressProps>(
  ({ file, onCancel, onDelete, ...props }, ref) => {
    const dimensions = useWindowSize();
    const device = useDevice(dimensions);

    const onRemoveClick =
      file.progress < 100 ? onCancel : onDelete ?? undefined;

    return (
      <div className="file-upload-progress" ref={ref} {...props}>
        <div className="fup-file">
          <div className="fup-info">
            <div className="fup-data">
              <div className="fup-label">
                {device === 'desktop' && (
                  <Icon
                    type="upload-file"
                    size="medium"
                    color="var(--color_neutral-dark)"
                  />
                )}
                <span className="fup-name">{file.name}</span>
              </div>
              <span className="fup-size">
                {file.loaded} of {file.total}
              </span>
            </div>

            <span className="fup-progress-value">{file.progress}%</span>
          </div>

          <progress
            className="fup-progress-bar"
            value={file.progress}
            max="100"
          />
        </div>

        {onRemoveClick != null && (
          <Button
            variant="tertiary"
            kind="danger"
            size="small"
            onClick={onRemoveClick}
            leadingIcon={<Icon type="trash" />}
          />
        )}
      </div>
    );
  },
);

export { FileUploadProgress };
